export enum BudgetPricingModel {
    TimeAndMaterial = 0,
    FixedPrice = 1,
    CappedTimeAndMaterial = 2,
    PrepaidHours = 3,
    Retainer = 4,
}

export enum BudgetRecurrenceType {
    None = 0,
    Monthly = 1,
    Quarterly = 2,
    Yearly = 3,
    Custom = 4,
}

export enum BudgetCarryOverType {
    None = 0,
    Full = 1,
    Limited = 2,
    Percentage = 3,
}

export enum BudgetOveragePolicy {
    Billable = 0,
    NonBillable = 1,
    RequiresApproval = 2,
    NotAllowed = 3,
}

export enum BudgetCapacityUnit {
    Hours = 0,
    Days = 1,
}

export enum BudgetCapacityInterval {
    None = 0,
    Weekly = 1,
    Monthly = 2,
    Quarterly = 3,
    Yearly = 4,
}
